import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Chip, TableCell, TableRow } from '@mui/material';
import { HTMLAttributes } from 'react';
import dayjs from 'dayjs';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { useTranslation } from 'react-i18next';
import { OnoffType, ShowTimeType } from '@/api/enum/common.enum';
import { showLabel } from '@/utils/helper';
import PublishedChip from '@/common/components/PublishedChip';
import { PUBLISHED_LISTB } from '@/common/constants/common';

type Props = {
	item: any;
} & HTMLAttributes<HTMLDivElement>;

const SortableArticlesItem = ({ item }: Props) => {
	const { t } = useTranslation();
	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({
		id: item.id,
	});

	const styles = {
		transform: CSS.Transform.toString(transform),
		transition: transition || undefined,
		opacity: isDragging ? '0.4' : '1',
		backgroundColor: isDragging ? '#F5F5F5' : '',
	};

	const showTimeTypeList = [
		{ id: ShowTimeType.Every, name: t('dialogList.every') },
		{ id: ShowTimeType.Once, name: t('dialogList.once') },
		{ id: ShowTimeType.One, name: t('dialogList.one') },
	];

	return (
		<>
			<TableRow ref={setNodeRef} style={styles}>
				<TableCell component='th' scope='row'>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<DehazeIcon cursor={'pointer'} {...listeners} {...attributes} />
						{`${item.titleZh || '-'}`}
					</Box>
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.showPageNames || '-'}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{showLabel(item?.type, showTimeTypeList)}
				</TableCell>
				<TableCell component='th' scope='row'>
					{item?.publishedAndroid && item?.publishedIos
						? 'iOS, Android'
						: item?.publishedAndroid
						? 'Android'
						: item?.publishedIos
						? 'iOS'
						: '-'}
				</TableCell>
				<TableCell component='th' scope='row'>
					{
						<PublishedChip
							published={item?.published}
							publishList={PUBLISHED_LISTB}
						/>
					}
				</TableCell>

				<TableCell component='th' scope='row'>
					{`${
						!item.publishedEndAt
							? '-'
							: dayjs(item.publishedEndAt)
									.locale('en')
									.format(DISPLAY_DATETIME_12H_FORMAT)
					}`}
				</TableCell>
			</TableRow>
		</>
	);
};

export default SortableArticlesItem;
